import { createTransform } from 'redux-persist'
import { TemplatesPendingReviewState, initialState } from './templatesPendingReviewSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  TemplatesPendingReviewState,
  Omit<TemplatesPendingReviewState, 'currentRequest' | 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, currentRequest, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: TemplatesPendingReviewState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      currentRequest: initialState.currentRequest,
      status,
    }
  },
  {
    whitelist: ['templatesPendingReivew'],
  },
)
